import CryptoJS from 'crypto-js';

const key = 'R7fyhOU1RxNYnMHjh20NcVYo+ED1h89LfYHolCZCLP4';

export async function encrypt(data:any) {
  var ciphertext = CryptoJS.AES.encrypt(data, key).toString();
  return ciphertext
}

export async function decrypt(data:any) {
  var bytes = CryptoJS.AES.decrypt(data, key);
  var dateText = bytes.toString(CryptoJS.enc.Utf8);
  return dateText
}